module.exports = __webpack_public_path__ + "static/img/pic_email_2.bbfa6121.png";